import HotelBenefits from 'blocks/HotelBenefits';
import HotelPreOpening from 'blocks/HotelPreOpening';
import ShortInfo from 'blocks/ShortInfo/ShortInfo';
import { FC } from 'react';
import { HotelPublicType } from 'types/types';
import styles from './HotelInfo.module.css';

interface IHotelInfo {
  hotel: HotelPublicType;
}

const HotelInfo: FC<IHotelInfo> = ({ hotel }) => {
  const showInfo =
    typeof hotel.short_info === 'object' &&
    Object.keys(hotel.short_info).length > 0;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>{hotel.name}</h1>
        <h3 className={styles.location}>{hotel.location}</h3>
        {hotel.description && (
          <div className={styles.description}>{hotel.description}</div>
        )}
        {showInfo && hotel.short_info && <ShortInfo info={hotel.short_info} />}
      </div>
      {hotel.pre_opening && <HotelPreOpening firstOpen={hotel.first_open} />}
      {!hotel.pre_opening && hotel.benefits.length > 0 && (
        <HotelBenefits
          benefits={hotel.benefits}
          benefits_footnotes={hotel.benefits_footnotes}
        />
      )}
    </div>
  );
};

export default HotelInfo;
